import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

export function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(
      `https://biosurgebackend-1.onrender.com/api/userdata/reset-password/${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      }
    );

    const data = await res.json();
    alert(data.message);

    if (res.ok) navigate("/login");
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2 className="auth-heading">Reset Password</h2>

        <div className="form-group">
          <label>New Password</label>
          <input
            type=""
            placeholder="Enter new secure password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="btn auth-btn" type="submit">
          Update Password
        </button>
      </form>
    </div>
  );
}

export default ResetPassword;
